module.exports = __webpack_public_path__ + "images/182_4096.jpg";